"use client";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import getLanguage from "@workspace/casino_pages/legacyLayer/client/utils/getLanguage";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import getLanguageDir from "@workspace/casino_pages/legacyLayer/shared/utils/getLanguageDir";
import CloseButton from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/OptInNotificationView/CloseButton";

const OptInNotificationView: FC<NotificationViewProps> = ({
  onClose,
  context,
}) => {
  const lang = getLanguage();
  const dir = getLanguageDir(lang);
  const isRtl = dir === "rtl";
  return (
    <div
      data-testid="optin-notification"
      className={classNames(
        "relative grid w-[-webkit-fill-available] cursor-pointer gap-4 rounded-lg bg-foreground p-4 text-left shadow-xs md:pointer-events-auto md:w-80",
        isRtl && "text-right",
      )}
      onClick={onClose}
    >
      <p className="text-background">
        <Translation
          id="promotion.optin_notification"
          translations={context.translations}
        />
      </p>
      <CloseButton onClose={onClose} />
    </div>
  );
};
export default OptInNotificationView;
